import {observer} from 'mobx-react';
import {Button, QuickTip} from 'shared/components';
import {DomainStore} from 'shared/store';
import {calendarDate} from 'shared/tools';
import {types} from 'main/tools';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';

const store = new DomainStore();

const WARNING_EXPLANATIONS = {
  retroactive_pay_rates: 'nmbr.updates.directory.RETROACTIVE_CHANGES_WARNING',
  retroactive_synced_hours: 'nmbr.updates.directory.CHANGES_NOT_SYNCED_WARNING'
};

const ResolutionControl = observer(({nmbrUpdate, fieldUpdate}) => {
  const resolved = !!fieldUpdate.resolvedAt;
  const linkName = resolved ? 'unresolve' : 'resolve';

  const patchResolution = async () => {
    const {model} = await store.patch(
      nmbrUpdate.link(linkName),
      types.NMBR.UPDATE,
      {fieldUpdateIndex: fieldUpdate.index}
    );

    if (model) nmbrUpdate.update(model);
  };

  return (
    <div className='flex align-items-middle gap-2'>
      {resolved && <div className='h5 jumbo regular'>
        <FormattedMessage
          id='nmbr.updates.directory.RESOLVED_BY'
          values={{
            name: fieldUpdate.resolvedByUserName,
            date: calendarDate(fieldUpdate.resolvedAt)
          }}
        />
      </div>}
      {nmbrUpdate.hasLink(linkName) && <Button size='sm' trait='default' onClick={patchResolution}>
        <FormattedMessage id={resolved ?
          'nmbr.updates.directory.Unresolve' :
          'nmbr.updates.directory.Mark as Resolved'}
        />
      </Button>}
    </div>
  );
});

const RetroactiveChangesWarning = observer(({nmbrUpdate}) => {
  if (_.isEmpty(nmbrUpdate.retroactiveFieldUpdates)) return null;

  return (
    <div className='mb2 space-y'>
      {nmbrUpdate.retroactiveFieldUpdates.map(fieldUpdate => (
        <QuickTip
          key={fieldUpdate.index}
          trait={fieldUpdate.resolvedAt ? 'success' : 'caution'}
          header={
            <div className='flex align-items-middle justify-content-between gap-2'>
              <FormattedMessage id='nmbr.updates.directory.Manual Intervention Required'/>
              <ResolutionControl nmbrUpdate={nmbrUpdate} fieldUpdate={fieldUpdate}/>
            </div>
          }
        >
          <FormattedMessage
            id={WARNING_EXPLANATIONS[fieldUpdate.updateType]}
            values={{
              effectiveDate: calendarDate(fieldUpdate.effectiveDate),
              cutoffDate: calendarDate(fieldUpdate.cutoffDate)
            }}
          />
        </QuickTip>
      ))}
    </div>
  );
});

export default RetroactiveChangesWarning;
